module.exports = __webpack_public_path__ + "static/media/Q4 - Modern.8707e3d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Survey/images/Q4 - Modern.png
// module id = 601
// module chunks = 0